import { useState } from "react";
import "./styles.css";
import {
  Button,
  SwipeableDrawer,
  Box,
  Typography,
  Dialog,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AudioPlayer from "../../AudioPlayer";
import { useTranslationSetup } from "../../utils/useTranslationSetup";

const AssessmentSaveAudioConfirmationDrawer = ({
  openDrawer,
  setOpenDrawer,
  audioBlob,
  setAudioBlob,
  onClickRetakeButton,
  onClickSaveButton,
}) => {
  const [assessmentAudioElementRef, setAssessmentAudioElementRef] =
    useState(null);
  const { t } = useTranslationSetup();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleOnClickSaveButton = () => {
    if (assessmentAudioElementRef !== null) {
      assessmentAudioElementRef.current?.pause();
    }
    onClickSaveButton();
  };

  const content = (
    <>
      <Typography className="listen-to-recording-text">
        {t("listen_to_recording")}
      </Typography>
      {audioBlob && (
        <Box className="audio-player-box">
          <AudioPlayer
            audioBlobForAudioPlayer={audioBlob}
            setAudioBlobForAudioPlayer={setAudioBlob}
            testedAudioElementRef={assessmentAudioElementRef}
            setTestedAudioElementRef={setAssessmentAudioElementRef}
          />
        </Box>
      )}
      <Box className="two-buttons-container">
        <Typography className="save-audio-confirmation-text">
          {t("are_you_sure_to_submit_recording")}
        </Typography>
        <Box className="submit-recording-container">
          <Box className="submit-button-container">
            <Button
              className="submit-button"
              disableElevation
              variant="contained"
              onClick={handleOnClickSaveButton}
            >
              {t("submit")}
            </Button>
          </Box>
          <Box className="retake-button-container">
            <Button
              className="retaking-button"
              disableElevation
              variant="outlined"
              onClick={onClickRetakeButton}
            >
              {t("retake")}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      {isDesktop ? (
        <Dialog
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          className="save-audio-confirmation-dialog"
        >
          {content}
        </Dialog>
      ) : (
        <SwipeableDrawer
          anchor="bottom"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          onOpen={() => setOpenDrawer(true)}
          transitionDuration={1000}
          className="save-audio-confirmation-drawer"
        >
          {content}
        </SwipeableDrawer>
      )}
    </>
  );
};

export default AssessmentSaveAudioConfirmationDrawer;
